import { render, staticRenderFns } from "./ImportExportLimits.vue?vue&type=template&id=2b9462d7&scoped=true&"
import script from "./ImportExportLimits.vue?vue&type=script&lang=js&"
export * from "./ImportExportLimits.vue?vue&type=script&lang=js&"
import style0 from "./ImportExportLimits.vue?vue&type=style&index=0&id=2b9462d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9462d7",
  null
  
)

export default component.exports